import { NzSelectSizeType } from 'ng-zorro-antd/select';

/* eslint-disable no-unused-vars */
export enum WrapFormItemEnum {
  INPUT = 'input',
  TEXTAREA = 'textarea',
  SELECT = 'select',
}

interface FormItemLabelModel {
  required: boolean;
  text: string;
  tooltip: string;
  type: string;
  class: string;
}

interface FormItemStandardFieldsModel {
  name: string;
  placeholder: string;
}

interface FormItemInputModel extends FormItemStandardFieldsModel {
  pattern: string;
}
interface FormItemTextAreaModel extends FormItemStandardFieldsModel {
  maxLength?: number;
  rows?: number;
}
interface FormItemSelectModel extends FormItemStandardFieldsModel {
  size: NzSelectSizeType;
  options: {
    source: any;
    key: string;
    value: string;
  };
}

export interface WrapFormItemModel {
  class?: string;
  label: FormItemLabelModel;
  formControl: {
    [WrapFormItemEnum.INPUT]?: FormItemInputModel;
    [WrapFormItemEnum.TEXTAREA]?: FormItemTextAreaModel;
    [WrapFormItemEnum.SELECT]?: FormItemSelectModel;
  };
}
